<template>
  <div id="app">
    <story-text></story-text>
    <transition name="offCanvasSlideRight">
      <div class="main-ui" :class="{ active: drawerOpen }" v-show="drawerOpen || mobileOpen">
        <navigation></navigation>
        <transition
          name="offCanvasSlideRight"
          @after-leave="afterDrawerClose"
        >
          <ship-information v-show="drawerOpen"></ship-information>
        </transition>
      </div>
    </transition>
    <introduction></introduction>
    <div class="" id="audio-toggle" @click="toggleAudio" :class="{ light: drawerOpen || mobileOpen, lightDesktop: drawerOpen }">
      <img src="@/../static/images/graphics/speaker-on-light.svg" alt="Audio On" class="light on" v-show="!muteAudio">
      <img src="@/../static/images/graphics/speaker-on-dark.svg" alt="Audio On" class="dark on" v-show="!muteAudio">
      <img src="@/../static/images/graphics/speaker-off-light.svg" alt="Audio Off" class="light off" v-show="muteAudio">
      <img src="@/../static/images/graphics/speaker-off-dark.svg" alt="Audio Off" class="dark off" v-show="muteAudio">
    </div>
    <div class="social" :class="{ active: mobileOpen || drawerOpen }">

      <!-- <div class="social-element">
        <img src="@/../static/images/graphics/share.svg" alt="Share">
      </div> -->

      <div class="social-element">
        <a :href="facebookLink" target="_blank" class="social-link" id="facebook-link">
          <img src="@/../static/images/graphics/facebook.svg" alt="Share">
        </a>
      </div>
      <div class="social-element">
        <a :href="twitterLink" target="_blank" class="social-link" id="twitter-link">
          <img src="@/../static/images/graphics/twitter.svg" alt="Share">
        </a>
      </div>
    </div>
    <div class="credits-container" :class="{ active: showCredits }">
      <div class="overlay" @click="toggleCredits()"></div>
      <div class="credits-content">
        <img src="@/../static/images/graphics/close.svg" alt="Close" class="close" @click="toggleCredits()">
        <p>Audio Credits:</p>
        <p class="credit"><a href="https://freesound.org/people/Henrythetrain/" target="_blank">Henrythetrain</a></p>
        <p class="credit"><a href="https://freesound.org/people/CGEffex/" target="_blank">CGEffex</a></p>
        <p><a href="https://creativecommons.org/licenses/by/3.0/" target="_blank">License</a></p>
      </div>
    </div>
    <div class="credits-toggle" id="credits-toggle" :class="{ light: drawerOpen || mobileOpen }" @click="toggleCredits()">
      <img src="@/../static/images/graphics/info-dark.svg" alt="More Information" class="info-dark">
      <img src="@/../static/images/graphics/info-light.svg" alt="More Information" class="info-light">
    </div>
  </div>
</template>

<script>
// active: drawerOpen,
import { mapGetters, mapMutations } from 'vuex';
import StoryText from './components/StoryText';
import Introduction from './components/Introduction';
import Navigation from './components/Navigation';
import ShipInformation from './components/ShipInformation';

const explosionMp3 = require('@/../static/audio/main-explosion.mp3');
const explosionOgg = require('@/../static/audio/main-explosion.ogg');
const loopMp3 = require('@/../static/audio/explosion-loop.mp3');
const loopOgg = require('@/../static/audio/explosion-loop.ogg');

export default {
  name: 'app',
  components: {
    StoryText,
    Introduction,
    Navigation,
    ShipInformation,
  },
  data() {
    return {
      showCredits: false,
      facebookLink: '',
      twitterLink: '',
    };
  },
  computed: {
    ...mapGetters('ui', [
      'drawerOpen',
      'mobileOpen',
      'playExplosion',
    ]),
    ...mapGetters('audio', [
      'muteAudio',
    ]),
  },
  mounted() {
    // first explosion
    this.explosion = new Audio();
    if (this.explosion.canPlayType('audio/mpeg')) {
      this.explosion.src = explosionMp3;
    } else {
      this.explosion.src = explosionOgg;
    }
    // background loop
    this.backgroundLoop = new Audio();
    if (this.backgroundLoop.canPlayType('audio/mpeg')) {
      this.backgroundLoop.src = loopMp3;
    } else {
      this.backgroundLoop.src = loopOgg;
    }
    this.backgroundLoop.loop = true;

    this.explosion.muted = this.muteAudio;
    this.backgroundLoop.muted = this.muteAudio;

    // social links
    const url = window.location.href;
    this.facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    this.twitterLink = `http://twitter.com/share?text=Explore the shipwrecks from %23BikiniAtoll’s nuclear bomb tests in 1946 – it’s the perfect %23scubadiving adventure!&url=${url}`.replace(' ', '+');
  },
  beforeDestroy() {
    this.explosion.pause();
    this.backgroundLoop.pause();
  },
  methods: {
    ...mapMutations('ships', ['setCurrentShip']),
    ...mapMutations('audio', ['setMuteState']),
    afterDrawerClose() {
      this.setCurrentShip({ ship: null });
    },
    toggleAudio() {
      this.setMuteState({ mute: !this.muteAudio });
    },
    toggleCredits() {
      this.showCredits = !this.showCredits;
    },
  },
  watch: {
    playExplosion() {
      if (this.playExplosion) {
        this.explosion.play();
        setTimeout(() => {
          this.backgroundLoop.play();
        }, 4000);
      }
    },
    muteAudio() {
      this.explosion.muted = this.muteAudio;
      this.backgroundLoop.muted = this.muteAudio;
    },
  },
};
</script>

<style lang='scss'>
  #app {
    position: relative;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
    background: #000;
  }

  .main-ui {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    // transform: translateX(100%);
    transition: transform 500ms;

    &.active, &.mobileActive {
      transform: translateX(-100%);
    }
  }

  #audio-toggle {
    color: #fff;
    position: absolute;
    top: 20px;
    left: 20px;
    width: 25px;
    height: 25px;
    cursor: pointer;

    img {
      position: absolute;
      width: 100%;
      height: auto;
      transition: .3s opacity;
      &.dark {
        opacity: 1;
      }
      &.light {
        opacity: 0;
      }
    }

    &.light {
      img {
        &.dark {
          opacity: 0;
        }
        &.light {
          opacity: 1;
        }
      }
    }
  }

  #credits-toggle {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 15px;
    height: 15px;
    cursor: pointer;
    img {
      position: absolute;
      width: 100%;
      height: auto;
      transition: .2s opacity;

      &.info-light {
        opacity: 0;
      }
      &.info-dark {
        opacity: 1;
      }
    }

    &.light {
      img {
        &.info-light {
          opacity: 1;
        }
        &.info-dark {
          opacity: 0;
        }
      }
    }
  }

  .credits-container {
    opacity: 0;
    position: fixed;
    pointer-events: none;
    width: 100%;
    height: 100%;
    transition: 300ms opacity;

    .overlay {
      width: 100%;
      height: 100%;
      background-color: rgba(1,2,1, 0.5);
    }

    .credits-content {
      width: 90%;
      max-width: 300px;
      color: #fff;
      background-color: #000;
      padding: 20px;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      a {
        color: #fff;
        text-decoration: none;
      }

      p.credit {
        font-size: 14px;
        line-height: 17px;
      }
      p:last-of-type {
        margin-top: 50px;
      }

      .close {
        width: 20px;
        height: auto;
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
      }
    }

    &.active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .social {
    position: absolute;
    bottom: 10px;
    right: 50px;
    transition: 300ms opacity;
    opacity: 0;

    &.hideSocial {
      opacity: 0;
    }

    .social-element {
      display: inline-block;
      height: 15px;
      margin: 0 5px;
      img {
        width: auto;
        height: 100%;
      }
    }

    &.active {
      opacity: 1;
    }
  }

  @media screen and (min-width: 768px) {
    #audio-toggle {
      width: 35px;
      height: 35px;
    }
  }

  @media screen and (min-width: 992px) {
    .social {
      transform: none;
      left: auto;
      right: 70px;
      bottom: 10px;
    }
    #audio-toggle {
      width: 35px;
      height: 35px;
      img {
        &.dark {
          opacity: 1;
        }
        &.light {
          opacity: 0;
        }
      }
      &.light {
        img {
          &.dark {
            opacity: 1;
          }
          &.light {
            opacity: 0;
          }
        }
      }
      &.lightDesktop {
        img {
          &.dark {
            opacity: 0;
          }
          &.light {
            opacity: 1;
          }
        }
      }
    }

    #credits-toggle {
      img {
        &.info-light {
          opacity: 1;
        }
        &.info-dark {
          opacity: 0;
        }
      }
      &.light {
        &.info-light {
          opacity: 1;
        }
        &.info-dark {
          opacity: 0;
        }
      }
    }
  }

  // offCanvasSlideRight
  .offCanvasSlideRight-enter-active, .offCanvasSlideRight-leave-active {
    transform: translateX(0);
  }
  .offCanvasSlideRight-enter, .offCanvasSlideRight-leave-to {
    transform: translateX(100%);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to {
    opacity: 0
  }

  @media screen and (min-width: 992px) {
    .main-ui {
      display: block !important;
      transform: translateX(60%);

      &.mobileActive {
        transform: translateX(60%);
      }

      &.active {
        transform: translateX(0%) !important;
      }
    }
  }

  @media screen and (min-width: 992px) {

  }
</style>



// WEBPACK FOOTER //
// App.vue?40c55522